import React from "react";
import ReactApexChart from "react-apexcharts";
import dayjs from "dayjs"; // For formatting dates

const FirstTrainingBarChart = ({ data }) => {
  console.log("data", data);

  // Clean up the percentage value to remove "--" or any negative sign
  const cleanPercentage = (percentage) => {
    // Ensure the percentage is a string before applying replace
    const percentageStr = String(percentage);

    // If the percentage is negative, return 0
    if (parseFloat(percentageStr) < 0) {
      return "0"; // Return '0' as a string to maintain consistency
    }

    // Remove any unwanted '--' or leading negative signs
    return percentageStr.replace(/^--/, "").replace("-", "");
  };

  const chartData = {
    series: [
      {
        data: data?.map((item) => cleanPercentage(item?.percentage)), // Clean percentage before using it
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: true,
          tools: {
            download: false,
          },
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: false,
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#FFFFFF"],
        },
        formatter: function (val) {
          return val;
        },
      },
      xaxis: {
        categories: data?.map((item) => item?.month), // Dynamic categories based on data type
        labels: {
          style: {
            colors: "#FFFFFF",
          },
        },
        axisBorder: {
          color: "#FFFFFF",
        },
        axisTicks: {
          color: "#FFFFFF",
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#FFFFFF",
          },
        },
      },
      grid: {
        borderColor: "rgba(255, 255, 255, 0.1)",
      },
      fill: {
        colors: ["#6DD37F"],
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const gameData = data?.[dataPointIndex]?.datas;
          const averageScore =
            cleanPercentage(series[seriesIndex][dataPointIndex]) || "N/A"; // Clean percentage in tooltip
          const totalGames = gameData?.games || "N/A";
          const totalScore =
            gameData?.scoreTotal ||
            gameData?.hitsTotal ||
            gameData?.passingTotal ||
            "N/A";
          const category = w.globals.labels[dataPointIndex]; // Fetch the category (e.g., month)

          return `
            <div style="padding: 8px; background-color: #1E1E2F; color: #FFFFFF; border-radius: 4px;">
              <div><strong>${category}</strong></div>
              <div style="border-bottom: 1px solid #FFFFFF; margin: 4px 0;"></div> <!-- Horizontal border -->
              <div>Percentage: ${averageScore}</div>
            </div>
          `;
        },
      },
    },
  };

  return (
    <div className="border p-4 rounded-lg mb-4">
      <p className="text-white text-base font-bold">
        Progression compared with first training
      </p>
      <div id="chart">
        {chartData && data?.length > 0 ? (
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={350}
          />
        ) : (
          <div className="flex justify-center text-white py-10">
            <p>No training took place</p>
          </div>
        )}
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default FirstTrainingBarChart;
